import { useState, useEffect, useContext } from 'react'
import { autorun, toJS } from 'mobx'
import { observer } from 'mobx-react'
import { Input } from 'antd'
import { TreeContext, OrgTree, LoadableButton, PictureThumb } from 'src/components'
import { $consts } from 'src/plugins'

const TreeNode = observer((props: { data: any }) => {
  const tree = useContext(TreeContext)

  const [btns, setBtns] = useState<any>([])
  useEffect(() => autorun(() => {
    setBtns(tree.getShowBtns(tree.enableBtns, [props.data]))
  }), [])

  const { Node } = props.data
  return (
    <div className='tree-page__org-node'>
      <PictureThumb
        picFilter={tree.treeConfig.Nav_PicFilter}
        targetData={props.data}
        className='tree-page__org-node--content'
      >
        {
          btns.length
            ? (
              <div className='tree-page__org-node--contentDefault'>
                <LoadableButton
                  pageType={$consts['TABLE/FORM_TYPE_TREE_PAGE']}
                  locateBtn={$consts['TABLE/BTN_LOCATE_SIDER']}
                  config={{ __RECORD__: Node, ...btns[0] }}
                />
              </div>
            )
            : null
        }
      </PictureThumb>
      <div title={Node?.NAME} className='tree-page__org-node--title'>{Node?.NAME}</div>
      {
        btns.length
          ? (
            <div className='tree-page__org-node--btns'>
              {/** btnsInner 是为了 hover */}
              <div className='tree-page__org-node--btnsInner'>
                {
                  btns.map((btn: any, index: number) => {
                    return (
                      <LoadableButton
                        key={`${btn.ID}_${index}`}
                        pageType={$consts['TABLE/FORM_TYPE_TREE_PAGE']}
                        locateBtn={$consts['TABLE/BTN_LOCATE_SIDER']}
                        config={{ __RECORD__: Node, ...btn }}
                      />
                    )
                  })
                }
              </div>
            </div>
          )
          : null
      }
    </div>
  )
})

const TreePageOrg = () => {
  const tree = useContext(TreeContext)

  const { treeConfig, treeData, enableBtns, visibleTreeData, pageDomSize } = tree
  const { Nav_PageTree = {} } = treeConfig
  const { CAN_ADD_NODE } = Nav_PageTree

  if (!treeData.length || !pageDomSize.clientHeight) {
    if (!treeData.length && CAN_ADD_NODE) {
      const addBtns = enableBtns.filter((btn: any) => {
        return btn.BTN_TYPE === $consts['TABLE/BTN_TYPE_ADD'] || btn.IS_SAME_LEVEL
      })
      const sameLevelBtn = addBtns.find((btn: any) => btn.IS_SAME_LEVEL) ?? addBtns[0]
      if (sameLevelBtn) {
        return (
          <LoadableButton
            pageType={$consts['TABLE/FORM_TYPE_TREE_PAGE']}
            locateBtn={$consts['TABLE/BTN_LOCATE_SIDER']}
            config={sameLevelBtn}
          />
        )
      }
      return <p>没有配置新增按钮</p>
    }

    return null
  }

  return (
    <div className='tree-page__org'>
      <Input.Search
        allowClear
        onSearch={val => tree.setSearchKey(val)}
        placeholder='关键字搜索'
        className='tree-page__org-search'
      />
      <div className='tree-page__org-main'>
        {
          visibleTreeData.map((tree: any, index: number) => {
            return (
              <OrgTree
                key={`${tree.Node?.ID}_${index}`}
                data={toJS(tree)}
                expandLevel={Nav_PageTree.LEVEL}
                renderContent={(data: any) => <TreeNode key={data.Node?.ID} data={data} />}
              />
            )
          })
        }
      </div>
    </div>
  )
}

export default observer(TreePageOrg)